<template>
  <div class="content-wrapper">
    <div class="ml-lg-4" style="max-width: 100%; overflow-x: auto">
      <vs-tabs
        class="mb-0"
        v-model="viewIndex"
        style="width: auto; float: left"
      >
        <vs-tab label="Lead" @click="setView('lead')">
          <div></div>
        </vs-tab>
        <vs-tab label="Grab Offer" @click="setView('offer')">
          <div></div>
        </vs-tab>
      </vs-tabs>

      <i
        class="fas fa-file-download fa-2x cursor-pointer hover:text-primary"
        @click="onExport()"
      ></i>
    </div>
    <vx-card>
      <template>
        <b-table
          ref="table"
          style="min-height: 600px"
          striped
          hover
          fixed
          responsive
          show-empty
          sort-icon-left
          :selectable="true"
          :select-mode="`multi`"
          :busy.sync="isBusy"
          :items="data"
          :fields="columns"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :filterIncludedFields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
        >
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2" style="height: 600px">
              <b-spinner class="align-middle"></b-spinner>
              <div class="mt-3">
                <strong>Loading...</strong>
              </div>
            </div>
          </template>
        </b-table>
      </template>
    </vx-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Service from "@/services";
import moment from "moment";

import XLSX from "xlsx"; // import xlsx
export default {
  watch: {
    view: function (newVal, oldVal) {
      let data = null;
      if (newVal == "lead") {
        data = {
          e: this.$route.query.e,
          slug: this.$route.query.e + "-lead",
        };

        this.columns = [
          {
            label: "Date",
            key: "date",
          },
          {
            label: "Reference",
            key: "reference",
          },
          {
            label: "Company Name",
            key: "company_name",
          },
          {
            label: "First Name",
            key: "firstname",
          },
          {
            label: "Last Name",
            key: "lastname",
          },
          {
            label: "Email",
            key: "email",
          },
          {
            label: "Mobile",
            key: "mobile",
          },
        ];
      } else if (newVal == "offer") {
        data = {
          e: this.$route.query.e,
          slug: this.$route.query.e + "-grab-offer",
        };

        this.columns = [
          {
            label: "Date",
            key: "date",
          },
          {
            label: "Reference",
            key: "reference",
          },
          {
            label: "Company Name",
            key: "company_name",
          },
          {
            label: "Offer",
            key: "offer",
          },
          {
            label: "First Name",
            key: "firstname",
          },
          {
            label: "Last Name",
            key: "lastname",
          },
          {
            label: "Mobile",
            key: "mobile",
          },
        ];
      }

      let params = Object.keys(data)
        .map((key) => key + "=" + data[key])
        .join("&");

      this.loadData(params);
    },
  },
  data: () => ({
    isBusy: false,
    viewIndex: 0,
    view: "lead",
    currentPage: 1,
    perPage: 500,
    totalRows: 0,
    selected: [],
    search: "",
    filter: "",
    filterOn: [],
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    data: [],
    columns: [],
  }),
  created() {},
  methods: {
    loadData(params) {
      Service.Report.engagement(params).then((res) => {
        var groups = res.data.rows.reduce(function (obj, item) {
          obj[item.reference] = obj[item.reference] || [];
          //item["quantity"] = 0;
          obj[item.reference].push({
            ...item,
          });
          return obj;
        }, {});

        let rows = [];
        Object.keys(groups).map((key) => {
          rows.push({
            reference: key,
            origin_tbl: groups[key][0].origin_tbl,
            origin_id: groups[key][0].origin_id,
            date: moment(groups[key][0].created_at).format("DD-MM-YYYY HH:mm"),
            company_name: groups[key][0].booth.company.company_name,
            items: groups[key],
          });
        });
        this.data = rows;
        console.log(this.data);
        /*
        rows[0].items.map((item) => {
          this.columns.push({
            label: item.engagement.engagement_title,
            key: item.engagement.engagement_title.toLowerCase(),
          });
        });
        */

        this.data.map((item, index) => {
          if (this.view == "lead") {
            this.data[index].firstname = item.items[0].response;
            this.data[index].lastname = item.items[1].response;
            this.data[index].email = item.items[2].response;
            this.data[index].mobile = item.items[3].response;
          }
          if (this.view == "offer") {
            this.data[index].firstname = item.items[0].attendee.firstname;
            this.data[index].lastname = item.items[0].attendee.lastname;
            this.data[index].mobile = item.items[0].attendee.phone;
          }
        });
      });
    },
    setView(view) {
      this.view = view;
    },
    onExport() {
      let rows = [];
      let days = [];

      let header = this.columns.map((item, index) => {
        return { text: item.label };
      });

      rows = this.data.map((item, index) => {
        return {
          ...item,
        };
      });

      let dataExport = {};
      const dataWS = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "order_report.xlsx");
    },
  },
};
</script>